// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__fF_ba","h2":"Heading_h2__Vi3s1","h3":"Heading_h3__9lZl4"};